module.exports = __webpack_public_path__ + "static/ramenmiso-5f5dfa765c3577de8af3191dc9082585.jpg";